import AssignmentSubmissionModal, { SUBMISSION_VARIANT } from './AssignmentSubmissionModal';

export { SUBMISSION_VARIANT };
export default AssignmentSubmissionModal;
